import { Pipe, PipeTransform } from "@angular/core";
import { UtilEnumHelper } from "@rr/shared-util";

@Pipe({
  name: "rrUiCoreEnumOptions",
  standalone: true,
})
export class UiCoreEnumOptionsPipe implements PipeTransform {
  transform(enumType: object): { label: string; value: object[keyof object] }[] {
    return UtilEnumHelper.enumToOptions(enumType);
  }
}
